import { useState } from 'react';
import { projects } from '../data';
import s from './Projects.module.css';

const FILTER_KEYS = ['All','React.js','Node.js','IoT','Startup'];
const FILTER_MAP  = {
  'React.js': ['Edidact Learning Platform','Employee Medical Wellness App','Mbakop SaaS Products'],
  'Node.js':  ['Employee Medical Wellness App','Mbakop SaaS Products','Next IT Era — Agency'],
  'IoT':      ['IBM Maximo IoT Dashboards'],
  'Startup':  ['Next IT Era — Agency'],
};

export default function Projects() {
  const [f, setF] = useState(0);
  const key = FILTER_KEYS[f];
  const visible = f === 0 ? projects : projects.filter(p => FILTER_MAP[key]?.includes(p.name));

  return (
    <section id="projects" className={`sec ${s.darkBg}`} aria-label="Projects">
      <div className="sec-inner">
        <div className="sec-top">
          <div><div className="sec-num">03 — Work</div><h2 className="sec-h">Selected Projects</h2></div>
          <div className={s.filters}>
            {FILTER_KEYS.map((k,i) => (
              <button key={k} className={`${s.filter} ${f===i?s.active:''}`} onClick={()=>setF(i)}>{k}</button>
            ))}
          </div>
        </div>
        <div className={s.grid}>
          {visible.map((p, i) => <ProjectCard key={p.id} project={p} index={i} />)}
        </div>
      </div>
    </section>
  );
}

function ProjectCard({ project: p, index: i }) {
  const [hov, setHov] = useState(false);
  const [exp, setExp] = useState(false);
  return (
    <div
      className={s.card}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      onClick={()=>setExp(!exp)}
      style={{ animationDelay: `${i*0.08}s` }}
    >
      <div className={s.cardGlow} style={{ opacity: hov ? 1 : 0 }} />
      <div className={s.year}>{p.year}</div>
      <div className={s.num}>0{i+1}</div>
      <h3 className={s.title}>{p.name}</h3>
      <div className={s.cat}>{p.category || p.cat}</div>
      <p className={s.desc}>{p.desc}</p>
      <div className={s.tags}>{p.tags.map(t=><span key={t} className={s.tag}>{t}</span>)}</div>
      {exp && (
        <div className={s.expanded}>
          {(p.highlights||p.hi||[]).map((h,i)=>(
            <div key={i} className={s.hi}><span className={s.hiDot}>▸</span>{h}</div>
          ))}
        </div>
      )}
      <div className={s.arrow} style={{ opacity: hov?1:0, transform: hov?'translate(0,0)':'translate(4px,4px)' }}>↗</div>
    </div>
  );
}
